module.exports = __webpack_public_path__ + "static/media/receipt-text.40eca96c.svg";